export const context = 'HomePage/Tasklist'

export const [GET_BOOKING_LIST, GET_BOOKING_LIST_SUCCESS, GET_BOOKING_LIST_FAIL] = [
  `${context}/GET_BOOKING_LIST`,
  `${context}/GET_BOOKING_LIST_SUCCESS`,
  `${context}/GET_BOOKING_LIST_FAIL`,
]

export const [UPDATE_BOOKING_REAL_TIME, UPDATE_DATE_CURRENT_TIME, ON_CLICK_TASK_LIST] = [
  `${context}/UPDATE_BOOKING_REAL_TIME`,
  `${context}/UPDATE_DATE_CURRENT_TIME`,
  `${context}/ON_CLICK_TASK_LIST`,
]

export const [GET_CUSTOM_TASK_LIST, GET_CUSTOM_TASK_SUCCESS, GET_CUSTOM_TASK_FAIL] = [
  `${context}/GET_CUSTOM_TASK_LIST`,
  `${context}/GET_CUSTOM_TASK_SUCCESS`,
  `${context}/GET_CUSTOM_TASK_FAIL`,
]

export const [UPDATE_CUSTOM_TASK_LIST, UPDATE_CUSTOM_TASK_SUCCESS, UPDATE_CUSTOM_TASK_FAIL] = [
  `${context}/UPDATE_CUSTOM_TASK_LIST`,
  `${context}/UPDATE_CUSTOM_TASK_SUCCESS`,
  `${context}/UPDATE_CUSTOM_TASK_FAIL`,
]

export const UPDATE_TASK_LIST_PROCESS = `${context}/UPDATE_TASK_LIST_PROCESS`
export const UPDATE_REPEAT_REAL_TIME = `${context}/UPDATE_REPEAT_REAL_TIME`

export const RECEIVE_MULTI_BOOKING = 'RECEIVE_MULTI_BOOKING'

export const taskListSchema = {
  task_remaining_on_premises: {
    id: '0001',
    title: '構内滞留',
    name: 'task_remaining_on_premises',
    type: 1,
    prefix: '未受付',
    listItem: [],
  },
  task_assigns: {
    id: '0002',
    title: '長時間待機',
    name: 'task_assigns',
    type: 2,
    prefix: '未受付',
    listItem: [],
  },
  task_callings: {
    id: '0003',
    title: '未呼出',
    name: 'task_callings',
    type: 3,
    prefix: '未受付',
    listItem: [],
  },
  task_start_workings: {
    id: '0004',
    title: '作業未着手',
    name: 'task_start_workings',
    type: 4,
    prefix: '未受付',
    listItem: [],
  },
  task_finish_workings: {
    id: '0005',
    title: '作業未完了',
    name: 'task_finish_workings',
    type: 5,
    prefix: '未受付',
    listItem: [],
  },
  task_input_driver_phones: {
    id: '0006',
    title: 'TEL未登録',
    name: 'task_input_driver_phones',
    type: 6,
    prefix: '未受付',
    listItem: [],
  },
  task_confirm_time_arrivals: {
    id: '0007',
    title: '遅延見込',
    name: 'task_confirm_time_arrivals',
    type: 7,
    prefix: '未受付',
    listItem: [],
  },
  task_finish_receptions: {
    id: '0008',
    title: '遅延中',
    name: 'task_finish_receptions',
    type: 8,
    prefix: '未受付',
    listItem: [],
  },
}

export const TYPE_TASK_LIST = {
  Five: 5,
  Six: 6,
  Seven: 7,
  Eight: 8,
}
export const initialState = {
  task_remaining_on_premises: true,
  task_assigns: true,
  task_callings: true,
  task_start_workings: true,
  task_finish_workings: true,
  task_input_driver_phones: true,
  task_confirm_time_arrivals: true,
  task_finish_receptions: true,
}

export const STEP_TIME = 10
export const MAX_TIME = 240

export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DATE_TIME_FORMAT_API = 'YYYYMMDD HH:mm:ss'
export const DATE_DAY_TIME_HOURS_FORMAT = 'MM/DD HH:mm'
export const DATE_TIME_HOURS_FORMAT = 'HH:mm'
export const DAY_FORMAT = 'YYYYMMDD'
